import { computed, defineComponent, onBeforeUnmount, watch } from 'vue';
import { EnvCheckerService } from '@/services/env/checker.service';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import { UserService } from '@/services/user.service';
import StepOne from './components/stepOne.vue';
import StepTwo from './components/stepTwo.vue';
import StepThree from './components/stepThree.vue';
import StepFour from './components/stepFour.vue';
import ModalNoDevice from './components/modal/NoDevice.vue';
import GuideScreen from './components/modal/GuideScreen.vue';
import DeviceDisconnect from './components/modal/DeviceDisconnect.vue';
export default defineComponent({
  components: {
    StepOne: StepOne,
    StepTwo: StepTwo,
    StepThree: StepThree,
    StepFour: StepFour,
    ModalNoDevice: ModalNoDevice,
    GuideScreen: GuideScreen,
    DeviceDisconnect: DeviceDisconnect
  },
  setup: function () {
    declareProviders([EnvCheckerService]);
    var checkerService = useService(EnvCheckerService);
    var userService = useService(UserService);
    var steps = computed(function () {
      return checkerService.checkStep;
    });
    var currentStepItem = computed(function () {
      return checkerService.checkStep[checkerService.currentStepIndex];
    });
    var handleStep = function (index) {
      checkerService.goStep(index, true);
    };
    onBeforeUnmount(function () {
      checkerService.uninstall();
    });
    // watch(
    //   () => checkerService.deviceActiveStatus,
    //   (status: string) => {
    //     if (status === 'inactive') {
    //       checkerService.showDeviceDisconnect = true;
    //       checkerService.DeviceState.hasClickChecked = false;
    //     }
    //   }
    // );
    watch(function () {
      return userService.user;
    }, function (user) {
      if (user && user.userId) {
        // 初始化获取数据
        checkerService.initPage();
      }
    }, {
      immediate: true
    });
    return {
      steps: steps,
      currentStepItem: currentStepItem,
      handleStep: handleStep,
      checkerService: checkerService
    };
  }
});